<script lang="ts" setup></script>

<template>
  <div>
    <AppHeader :links="navLinks" />

    <AppNavBar :links="navLinks" />

    <UContainer class="mt-12 lg:pl-36">
      <slot />
      <LazyAppFooter />
    </UContainer>
  </div>
</template>
